import { render, staticRenderFns } from "./NewAccountSummary.vue?vue&type=template&id=656c541c&scoped=true&"
import script from "./NewAccountSummary.vue?vue&type=script&lang=js&"
export * from "./NewAccountSummary.vue?vue&type=script&lang=js&"
import style0 from "./NewAccountSummary.vue?vue&type=style&index=0&id=656c541c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656c541c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3001884671/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('656c541c')) {
      api.createRecord('656c541c', component.options)
    } else {
      api.reload('656c541c', component.options)
    }
    module.hot.accept("./NewAccountSummary.vue?vue&type=template&id=656c541c&scoped=true&", function () {
      api.rerender('656c541c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/NewAccountSummary.vue"
export default component.exports